export default __webpack_public_path__ + "static/media/1836.0aa0e5c3.png";